import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { LandingAuthService } from '../services/landing-auth.service';
import { isSkilledApiRequest } from './skilled-api-request';

/**
 * Attaches the landing site's Bearer token to authenticated API calls
 * (billing, packages, credit-card pay). Works alongside cookie sessions
 * when the visitor signed in on the marketing site.
 */
export const landingAuthInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  if (!isSkilledApiRequest(req.url)) {
    return next(req);
  }

  const token = inject(LandingAuthService).readToken();
  if (!token) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    }),
  );
};
